import React from 'react';
import './FinalSection.css';

const FinalSection: React.FC = () => {
  return (
    <section className="final-section">
      <div className="final-image"></div>
      <div className="final-content">
        <h2>ВТОРОЙ ЭТАП: ОЧНЫЙ ФИНАЛ</h2>
        
        <div className="info-blocks">
          <div className="info-block">
            <h3>МЕСТО</h3>
            <p>«Наноквантум», АНО ДТ «Красноярский Кванториум»</p>
          </div>

          <div className="info-block">
            <h3>ЗАДАЧА</h3>
            <p>Реализовать спланированный и обсчитанный эксперимент, провести лабораторные исследования по синтезу магнитных наночастиц типа «ядро-оболочка» с заданными свойствами</p>
          </div>

          <div className="info-block">
            <h3>РЕЗУЛЬТАТ</h3>
            <p>Победитель и призеры определяются по результатам независимой экспертизы полученных продуктов комплексом физико-химических методов анализа</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalSection; 